<template>
  <el-dialog v-model="state.visible" :show-close="false" width="610px" append-to-body>
    <template #title>
      <div class="title">
        {{ $t('product.editPrice') }}
        <img src="@/assets/images/common/close-icon.png" class="close-icon" @click="cancel" />
      </div>
    </template>
    <div class="content">
      <el-form ref="formRef" class="form" :model="state">
        <el-form-item label-width="60px" label="CNY" prop="price"
          :rules="{ required: true, message: $t('form.holder.inputContent') }">
          <el-input-number v-model="state.price" :placeholder="$t('form.holder.inputContent')" :min="0"
            :precision="2" />
        </el-form-item>

        <div class="tips">{{ $t('product.editPriceTips') }}</div>
        <div class="type-list">
          <div class="edit-type" v-for="item in [1, 2, 3]" :key="item" :class="{ active: state.activeIndex === item }"
            @click="clickLabel(item)">
            {{ $t(`product.editPriceEnum.${item}`) }}
          </div>
        </div>
        <el-form-item v-if="state.activeIndex === 3" label-width="60px" prop="comment"
          :rules="{ required: true, message: $t('form.holder.inputContent') }" :label="$t('order.remark')">
          <el-input v-model="state.comment" type="textarea" :placeholder="$t('form.holder.inputContent')" />
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button class="btn-cancel" @click="cancel">{{
          $t('common.cancel')
          }}</el-button>
        <el-button class="btn-confirm" type="primary" @click="submit">{{
          $t('common.confirm')
          }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { defineEmits, defineExpose, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const formRef = ref();
const $emit = defineEmits(['edit-price']);
const { t } = useI18n();
const state = reactive({
  visible: false,
  activeIndex: 0,
  price: undefined,
  comment: undefined
});

const cancel = () => {
  state.visible = false;
  state.price = undefined;
  state.activeIndex = 0;
};

const clickLabel = index => {
  state.activeIndex = index;
};

const submit = () => {
  formRef.value.validate(valid => {
    if (valid) {
      $emit('edit-price', {
        price: state.price,
        comment:
          state.activeIndex === 3
            ? state.comment
            : t(`product.editPriceEnum.${state.activeIndex}`)
      });
      cancel();
    }
  });
};

const openModal = () => {
  state.visible = true;
};
defineExpose({
  openModal
});
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
  line-height: normal;
  color: var(--black-color-9);
  padding: 0 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-icon {
  cursor: pointer;
  width: 14px;
  height: 14px;
}

.content {
  padding: 22px;

  .form {
    padding-bottom: 14px;
    border-bottom: 1px dashed #dadee6;
    margin-bottom: 10px;
  }

  .tips {
    font-size: 12px;
    font-weight: normal;
    line-height: 18px;
    color: var(--black-color-4);
    margin-bottom: 16px;
  }

  .type-list {
    display: flex;

    .edit-type {
      margin-right: 12px;
      margin-bottom: 16px;
      font-family: Montserrat;
      font-size: 12px;
      font-weight: normal;
      color: var(--black-color-9);
      padding: 8px;
      border: 1px solid var(--border-black-1);
      border-radius: 3px;
      cursor: pointer;

      &.active {
        border-color: var(--primary-color);
        color: var(--primary-color);
      }
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  ::v-deep(.el-form-item__label) {
    line-height: 40px;
    font-size: 14px;
    font-weight: normal;
    color: var(--black-color-3d);
  }

  ::v-deep(.el-input-number) {
    width: 100%;
  }

  ::v-deep(.el-input__wrapper) {
    padding: 0 12px;
  }

  ::v-deep(.el-input__inner) {
    text-align: left;
  }

  ::v-deep(.el-input-number__increase) {
    display: none;
  }

  ::v-deep(.el-input-number__decrease) {
    display: none;
  }

  ::v-deep {
    .el-textarea__inner {
      background-color: var(--white-color-1);
      box-shadow: 0 0 0 1px var(--el-border-color) inset;

      &:focus {
        box-shadow: 0 0 0 1px var(--el-color-primary) inset;
      }
    }
  }
}
</style>
